import { createFileRoute } from '@tanstack/react-router';
import { analyticsSearchSchema, buildDateRange } from '@/features/analytics/dateRange';
import { EventTimeseries } from '@/features/analytics/product/EventTimeseries';
import { TopEventsTable } from '@/features/analytics/product/TopEventsTable';
import { PlatformSplitChart } from '@/features/analytics/product/PlatformSplitChart';
import { ScreenFunnel } from '@/features/analytics/product/ScreenFunnel';
import { FeatureUsageSmallMultiples } from '@/features/analytics/product/FeatureUsageSmallMultiples';

export const Route = createFileRoute('/_authed/analytics/product')({
  validateSearch: (raw: Record<string, unknown>) => {
    const parsed = analyticsSearchSchema.safeParse(raw);
    return parsed.success ? parsed.data : {};
  },
  component: ProductPage,
});

function ProductPage() {
  const rawSearch = Route.useSearch();
  const range = buildDateRange({
    preset: rawSearch.preset,
    from: rawSearch.from,
    to: rawSearch.to,
  });

  return (
    <div className="flex flex-col gap-6" data-testid="analytics-product-page">
      <div data-testid="analytics-product-events">
        <EventTimeseries range={range} />
        <TopEventsTable range={range} />
        <PlatformSplitChart range={range} />
      </div>
      <div data-testid="analytics-product-features">
        <ScreenFunnel range={range} />
        <FeatureUsageSmallMultiples range={range} />
      </div>
    </div>
  );
}
